<div class="socialbox row">
  <small *ngIf="!social">{{ 'Portal.Hint.Social' | translate }}</small>
  <div class="row">
    <div label="Instagram">
      <form class="example-form">
        <div><i class="icon-instagram"></i></div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.instagram" name="instagram" #name="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Instagram' | translate }}">
          <a [href]="social.instagram" target="_blank" [hidden]="social.instagram == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

    <div label="Telegram">
      <form class="example-form">
        <div><i class="icon-telegram"></i></div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.telegram" name="telegram" #Telegram="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Telegram' | translate }}">
          <a [href]="social.telegram" target="_blank" [hidden]="social.telegram == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

    <div label="Twitter">
      <form class="example-form">
        <div><i class="icon-twitter"></i></div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.twitter" name="twitter" #Twitter="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Twitter' | translate }}">
          <a [href]="social.twitter" target="_blank" [hidden]="social.twitter == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

    <div label="Facebook">
      <form class="example-form">
        <div><i class="icon-facebook"></i></div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.facebook" name="facebook" #Facebook="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Facebook' | translate }}">
          <a [href]="social.facebook" target="_blank" [hidden]="social.facebook == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

    <div label="WhatsApp">
      <form class="example-form">
        <div class="icon-button">
          <i class="icon-whatsapp2"><i class="path2"></i></i>
        </div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.whatsApp" name="facebook" #WhatsApp="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Whatsapp' | translate }}">
          <a [href]="social.whatsApp" target="_blank" [hidden]="social.whatsApp == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

    <div label="Website">
      <form class="example-form">
        <div><i class="icon-circle"></i></div>
        <mat-form-field class="example-full-width">
          <input [(ngModel)]="social.website" name="website" #Website="ngModel" matInput placeholder="{{ 'Portal.SocialMedia.Website' | translate }}">
          <a [href]="social.website" target="_blank" [hidden]="social.website == ''">نمایش</a>
        </mat-form-field>
      </form>
    </div>

  </div>

      <div class="save">
        <button (click)="save()">
          ذخیره
        </button>
      </div>

    </div>
